export default "__VITE_ASSET__BqAOBit1__"